import React, { Children, cloneElement } from 'react';
import { BreadcrumbLink } from './breadcrumb-link.js';
import { BreadcrumbMultiple } from './breadcrumb-multiple.js';
import { BreadcrumbSingle } from './breadcrumb-single.js';
import './style.css.js';
import '@magnetic/theme';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const Breadcrumb = /* @__PURE__ */ __name(({
  children,
  ...rest
}) => {
  const countChildren = Children.count(children);
  if (countChildren === 0) {
    return null;
  }
  if (countChildren === 1) {
    return /* @__PURE__ */ React.createElement(BreadcrumbSingle, {
      ...rest
    }, cloneElement(children, {
      withArrow: true
    }));
  }
  return /* @__PURE__ */ React.createElement(BreadcrumbMultiple, {
    ...rest
  }, children);
}, "Breadcrumb");
Breadcrumb.Link = BreadcrumbLink;

export { Breadcrumb };
//# sourceMappingURL=index.js.map
